const STARTING_POSITIONS = {
    //Start at 1/1 to prevent our border from clipping upon being selected
    X: 1,
    Y: 1
}

const NODE_TYPES = {
    AUDIENCE: 'Audience'
};

const NODE_DIMENSIONS = {
    WIDTH: 10,
    
    MIN_HEIGHT: 10, // for very small ones
    MAX_HEIGHT: 200 // 100%
}

const CONNECTION_DIMENSIONS = {
    MIN_HEIGHT: 1
};

const SPACING = {
    VERTICAL: 20,
    HORIZONTAL: 150
}

export {
    STARTING_POSITIONS,
    NODE_TYPES,
    NODE_DIMENSIONS,
    CONNECTION_DIMENSIONS,
    SPACING
}